import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

export const DetailValueChartSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack bgcolor={theme.palette.background.paper} pt={theme.spacingTokens.xl}>
			<Stack px={theme.spacingTokens.lg} gap={theme.spacingTokens.xs}>
				<Skeleton variant="text" width={72} height={16} animation="wave" />
				<Skeleton variant="text" width="55%" height={34} animation="wave" />
				<Skeleton variant="text" width="40%" height={16} animation="wave" />
			</Stack>

			<Stack px={theme.spacingTokens.lg} pt={theme.spacingTokens.sm}>
				<Skeleton
					variant="rounded"
					width="100%"
					height={180}
					animation="wave"
				/>
			</Stack>

			<Stack
				direction="row"
				justifyContent="center"
				gap={theme.spacingTokens.xs}
				py={1}
			>
				{Array.from({ length: 6 }).map((_, index) => (
					<Skeleton
						// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
						key={index}
						variant="rounded"
						width={36}
						height={24}
						animation="wave"
						sx={{ borderRadius: theme.radii.full }}
					/>
				))}
			</Stack>

			<Stack px={theme.spacingTokens.lg} pt={theme.spacingTokens.sm}>
				{Array.from({ length: 2 }).map((_, index) => (
					<Stack
						// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
						key={index}
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						py={theme.spacingTokens.md}
					>
						<Skeleton variant="text" width="30%" height={16} animation="wave" />
						<Skeleton variant="text" width="25%" height={16} animation="wave" />
					</Stack>
				))}
			</Stack>
		</Stack>
	);
};
